<template>
  <Day day="04.12.2023">
    <div slot="page-content">
      <h1 class="headline mb-5 align-center px-5">Nincs karácsony...</h1>

      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>fények nélkül! </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-img style="margin: 0 auto" max-width="300" src="../../assets/dec4.jpg"></v-img>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </Day>
</template>
  
<script>
import Day from "@/views/days/Day.vue";

export default {
  name: "Day04",
  components: {
    Day,
  },
  mounted() {
    document.body.classList.add('breakfast')
  },
  destroyed() {
    document.body.classList.remove('breakfast')
  },
};
</script>
  

<style lang="scss">
.italic {
  font-style: italic;
}

p {
  font-size: 1.3em;
  line-height: 1.8;
}
</style>